import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

interface ViewArticleRelatedProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleRelated: React.FC<ViewArticleRelatedProps> = ({ entities }) => (
  <div className="ViewArticleRelated">
    {entities.map((entity) => {
      const article = entity.toJS();
      const id = article.nid[0].value;
      const uuid = article.uuid[0].value;
      const langcode = article.langcode[0].value;
      const key = `${uuid}:${langcode}`;

      return (
        <Node
          key={key}
          id={id}
          entity={entity}
          viewMode="teaser"
          classes="ArticleTeaser"
        />
      );
    })}
  </div>
);

export default ViewArticleRelated;
